<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_PROCESANDO' | translate }}</span>
  </div>
</div>
<div class="grid" *ngIf="!carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12">
    <p-panel header="{{ 'TIPOCAUSAL.LBL_TIPOCAUSAL' | translate}} : {{tipCausal.nombre}}">
      <div class="grid">
        <div class="col-12 lg:col-12 md:col-12 text-center">
          <div *ngIf="!guardando">
            <p-pickList [source]="iteDisponible" [target]="iteSeleccionado"
                        sourceHeader="{{'TIPOCAUSAL.LBL_CAUSALDISPONIBLE'|translate}}"
                        targetHeader="{{'TIPOCAUSAL.LBL_CAUSALASIGNADA'|translate}}"
                        (onMoveToTarget)="guardar($event.items, true)"
                        (onMoveToSource)="guardar($event.items, false)"
                        [showTargetControls]="false"
                        [showSourceControls]="false"
                         id="idItemLista" filterBy="nombreListaCausalSolicitud">
              <ng-template let-item pTemplate="item">
                {{ item.nombreListaCausalSolicitud }}
              </ng-template>
            </p-pickList>
          </div>
          <div *ngIf="guardando">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_GUARDANDO' | translate }}</span>
          </div>

        </div>
      </div>
      <div class="grid form-footer-buttons">
        <div class="form-group col-12">
          <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                  pButton (click)="regresar()"></button>
        </div>
      </div>
    </p-panel>
  </div>
</div>
